const TravelerHelper = (function() {
	/** Merge embedded API `traveler` and support snake_case name fields. */
	const resolveTravelerFields = traveler => {
		if (!traveler) return null;
		const embedded = traveler.traveler && typeof traveler.traveler === 'object' ? traveler.traveler : null;
		const t = embedded ? { ...traveler, ...embedded } : traveler;
		return {
			...t,
			firstName: t.firstName || t.first_name || '',
			lastName: t.lastName || t.last_name || '',
			telephone: t.telephone || t.phone || '',
			email: t.email || '',
			line: t.line || '',
			thaiFirstName: t.thaiFirstName || t.thai_first_name || '',
			thaiMiddleName: t.thaiMiddleName || t.thai_middle_name || '',
			thaiLastName: t.thaiLastName || t.thai_last_name || '',
		};
	};

	const getFullName = traveler => {
		if (!traveler) return '';
		const t = resolveTravelerFields(traveler);
		const nameEn = [t.firstName, t.lastName]
			.filter(Boolean)
			.join(' ')
			.trim();
		const nameTh = [t.thaiFirstName, t.thaiLastName]
			.filter(Boolean)
			.join(' ')
			.trim();

		// if (nameEn && nameTh) return `${nameEn}\n${nameTh}`;
		if (nameTh) return nameTh;
		if (nameEn) return nameEn;
		if (t.name && String(t.name).trim()) return String(t.name).trim();
		if (t.displayName && String(t.displayName).trim()) return String(t.displayName).trim();
		return '';
	};

	const getNameAndContact = traveler => {
		if (!traveler) return '';
		const t = resolveTravelerFields(traveler);
		const nameEn = [t.firstName, t.lastName].filter(Boolean).join(' ');
		const nameTh = [t.thaiFirstName, t.thaiLastName].filter(Boolean).join(' ');
		const fullName = (nameEn + ' ' + nameTh).trim();
		const contactValues = [t.telephone, t.email, t.line].filter(Boolean);
		const contact = contactValues.length > 0 ? `(${contactValues.join(' ')})` : '';
		const base = fullName || (t.name && String(t.name).trim()) || '';
		return `${base} ${contact}`.trim();
	};

	/** Use on DOM nodes that render getFullName() so embedded `\n` becomes a line break. */
	const fullNameStyle = { whiteSpace: 'pre-line' };

	return {
		getFullName,
		getNameAndContact,
		fullNameStyle,
	};
})();

export default TravelerHelper;
